// extracted by mini-css-extract-plugin
module.exports = {"action":"action__qXfiI","icon":"icon__kLumd","action-warning":"action-warning__hlmEE"};